import React, { FC } from 'react';
import { TypeNarrowCtaFields } from '@/core/generated-types';
import { UniversalCta } from '../UniversalCta';

const NarrowCta: FC<TypeNarrowCtaFields> = ({
  title,
  subtitle,
  trailingText,
  backgroundColor,
  cta,
  margin,
  maxWidth,
}) => {
  return (
    <div
      className={`bg-${backgroundColor?.fields?.color} pb-8`}
      style={{ marginTop: margin, marginBottom: margin }}
    >
      <div className="mx-auto px-6" style={{ maxWidth }}>
        <div className="pt-8 text-center text-2xl font-bold md:pt-0 md:text-[32px] md:leading-[44px]">
          {title}
        </div>
        {subtitle && (
          <div className="mx-auto pt-4 text-center text-base md:w-auto md:px-12 md:text-lg">
            {subtitle}
          </div>
        )}
        {cta && (
          <div className="flex items-center justify-center">
            <UniversalCta link={cta} className="mt-6" />
          </div>
        )}
        {trailingText && (
          <div className="mx-auto pt-4 text-center text-base md:w-auto md:px-12 md:text-lg">
            {trailingText}
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(NarrowCta);
